import React, {createContext, useState} from "react";
import PMSVendorServices from "../../services/pms_services/PMSVendorServices";
import Notification from "../../components/common/Notification";

export const PMSVendorLedgerContext = createContext("PMSVendorLedgerContext");

const PMSVendorLedgerContextProvider = ({children}) => {

    const [loading, setLoading] = useState(false);
    const [loadingDownload, setLoadingDownload] = useState(false);
    const [errorMsg, setErrorMsg] = useState("");
    const [vendor, setVendor] = useState(null);
    const [ledgerEntries, setLedgerEntries] = useState([]);
    const [totalElements, setTotalElements] = useState(0);
    const [openingBalance, setOpeningBalance] = useState(0);
    const [closingBalance, setClosingBalance] = useState(0);

    const getVendorLedger = async (pharmacyId, vendorId, params) => {
        try {
            setLoading(true);
            setErrorMsg("");
            const res = await PMSVendorServices.getVendorLedger(pharmacyId, vendorId, params);
            setVendor(res.data.vendor);
            setLedgerEntries(res.data.entries || []);
            setTotalElements(res.data.count || 0);
            setOpeningBalance(res.data.openingBalance || 0);
            setClosingBalance(res.data.closingBalance || 0);
            setLoading(false);
            return true;
        } catch (error) {
            setLoading(false);
            let _error = "Something went wrong.";
            if (error.message === "Network Error") _error = error.message;
            if (error.response && error.response.data) _error = error.response.data.message;
            setErrorMsg(_error);
            Notification("error", "ERROR", `${_error}`);
            return false;
        }
    };

    const getVendorLedgerForPrint = async (pharmacyId, vendorId, params) => {
        try {
            setLoadingDownload(true);
            const res = await PMSVendorServices.getVendorLedgerForPrint(pharmacyId, vendorId, params);
            setLoadingDownload(false);
            return res.data;
        } catch (error) {
            setLoadingDownload(false);
            let _error = "Something went wrong.";
            if (error.message === "Network Error") _error = error.message;
            if (error.response && error.response.data) _error = error.response.data.message;
            Notification("error", "ERROR", `${_error}`);
            return null;
        }
    };

    return (
        <PMSVendorLedgerContext.Provider
            value={{
                loading,
                loadingDownload,
                errorMsg,
                vendor,
                ledgerEntries,
                totalElements,
                openingBalance,
                closingBalance,
                getVendorLedger,
                getVendorLedgerForPrint,
            }}
        >
            {children}
        </PMSVendorLedgerContext.Provider>
    );
};

export default PMSVendorLedgerContextProvider;
